export default __webpack_public_path__ + "static/media/trello-left.19574ab7.svg";